/* @flow */

module.exports = {
  "LOCALE": {
    "CURRENCY": "SEK",
    "CURRENCY_SHORT": "kr",
  },
  "META": {
    "TITLE": "E.ON Webbshop",
    "NAME": "E.ON Webbshop",
    "DESCRIPTION": "E.ON Webbshop",
    "HELPDESK_LINK": "https://helpdesk.crossroads.se/?s=8b1b7f7e289a69a42e872427689875e4",
  }, "LOGO": {
    "ALT": "E.ON",
    "TITLE": "Gå till startsidan",
  },
  "SKIP_TO_CONTENT": "Gå till innehåll",
  "URL": {
    "CHECKOUT_CART": "/checkout/cart",
    "CHECKOUT_OVERVIEW": "/checkout/overview",
    "CHECKOUT_SUCCESS": "/checkout/success",
    "CHECKOUT_FAILED": "/checkout/overview",
  },
  "CURRENCY_SHORT": {
    "NOK": "kr",
    "DKK": "kr",
    "SEK": "kr",
    "EUR": "€",
  },
  "CLOSE_SYSTEM_MESSAGE": "Stäng meddelande",
  "PRICE": {
    "SHOP_PRICE": "Shoppris",
    "MSRP": "Ord. pris",
    "FROM": "från",
  },
  "HAMBURGER": {
    "TITLE": "Meny",
  },
  "HOMEVIEW": {
    "INTRO": "I vår webbshop hittar du som E.ON-kund produkter som gör ditt hem smartare, härligare och hemtrevligare - till exklusivt förmånliga priser. Gratis frakt vid beställningar över 500 kr.",
    "WHOLE_CATEGORY": "Se hela kategorin",
  },
  "ADVENT_CALENDAR": {
    "BACK": "Tillbaka till julkalendern",
    "DOOR_OPEN_X_DAYS": "Varje lucka är öppen i %days dagar",
    "CATEGORY_URL": "julkalender",
    "FORM": {
      "SUBSCRIBE_NOW": "Missa inte årets julkalender. Anmäl dig nu och få fina erbjudanden och energibesparingstips varje dag fram till jul!",
      "EMAIL": "E-mail",
      "SUBMIT": "Bekräfta anmälan",
    },
  },
  "SORT": {
    "OFFCANVAS": {
      "TITLE": "Sortera",
      "SHOW_RESULT": "Visa resultat",
      "CLOSE_MENU": "Stäng sortering",
    },
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Filtrera",
      "FILTER_BY_POINTS": "Filtrera på pris",
      "FILTER_BY_PRICE": "Filtrera på pris",
      "PRICE_RANGE_MIN": "%min kr",
      "PRICE_RANGE_MAX": "%max kr",
      "PRICE_RANGE": "%min - %max pris",
      "SORT": "Sortera",
      "SORT_DEFAULT": "Utvalda",
      "SORT_PRICE_DESC": "Pris ↓",
      "SORT_PRICE_ASC": "Pris ↑",
      "SORT_NAME_DESC": "Namn ↓",
      "SORT_NAME_ASC": "Namn ↑",
      "RANGESLIDER": "Skjutreglage",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total Produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total Produkter",
      "SHOW_RESULT": "Visa resultat",
      "CLOSE_MENU": "Stäng filter",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Rensa filter",
      "NO_ACTIVE_FILTERS": "Du har inga aktiva filter",
      "PRICE_RANGE": "Pris (%range)",
      "TOTAL_COUNT": "Visar %count produkter",
      "REMOVE": "Ta bort filter",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrera på pris",
      "FILTER_BY_POINTS": "Filtrera på pris",
      "RESET_PRICE": "Rensa filter",
      "PRICE_FROM": "Från",
      "PRICE_TO": "Till",
      "BALANCE_FILTER": "Filtrera på saldo (%value pris)",
      "WITHIN_BALANCE": "Produkter inom poängsaldo",
    },
  },
  "ADDRESS": {
    "FIRSTNAME": "Förnamn",
    "LASTNAME": "Efternamn",
    "STREET_1": "Gatuadress 1",
    "STREET_2": "Gatuadress 2 (frivilligt)",
    "POSTCODE": "Postnummer",
    "CITY": "Stad",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
  },
  "OR": "eller",
  "CART": {
    "MINI_HEADER": "Varukorg",
    "MINI_SHOW_LESS": "Visa mindre",
    "MINI_SHOW_MORE": "Se översikt",
    "MINI_SUBTOTAL": "Totalt",
    "MINI_QTY": "st",
    "HEADING": "Varukorg",
    "EMPTY": "Varukorgen är tom",
    "CTA": "Gå till varukorgen",
    "INCREMENT": "Öka kvantitet",
    "DECREMENT": "Minska kvantitet",
    "QUANTITY": "Kvantitet",
    "CONTINUE_SHOPPING": "Fortsätt handla",
    "TO_CHECKOUT": "Gå till kassan",
    "DIALOG_CANCEL": "Avbryt",
    "REMOVE_PRODUCT": "Ta bort produkt",
    "REMOVE_PRODUCT_SHORT": "Ta bort",
    "REMOVE_APPROVE": "Ja, ta bort",
    "CONFIRM_TEXT": "Vill du verkligen ta bort '%itemName' från varukorgen?",
    "SHIPPING": "Frakt",
    "DISCOUNT": "Rabatt",
    "SUB_TOTAL": "Ordervärde",
    "GRAND_TOTAL": "Att betala",
    "SUMMARY": "Summering",
    "FREE_SHIPPING_AT": "%left kvar till fri frakt!",
    "FREE_SHIPPING": "Fri frakt!",
    "OPEN_SUMMARY": "Öppna summering",
    "CLOSE_SUMMARY": "Stäng summering",
    "SUBMIT": "Spara antal produkter",
  },
  "SUMMARY": {
    "DISCOUNT": "Rabatt",
  },
  "DIALOGUE": {
    "CLOSE": "Stäng dialog",
  },
  "NOTIFICATIONBAR": {
    "CLOSE": "Stäng banner",
  },
  "CHECKOUT": {
    "TITLE": "Kassa",
    "NEED_HELP": "Behöver du hjälp?",
    "CONTINUE": "Fortsätt",
    "CONTACT_CUSTOMER_SERVICE": "Kontakta kundtjänst",
    "TO_PAYMENT": "Gå till betalning",
    "AMOUNT_TO_PAY": "Att betala",
    "EDIT": "Ändra",
    "BACK_TO_CART_TEXT": "Gå till varukorg",
    "COMPLETE_PURCHASE": "Slutför köp",
    "I_ACCEPT_THE": "Jag accepterar",
    "TERMS": "köpvillkoren",
    "TERMS_URL": "terms",
    "TERMS_CLOSE": "Stäng köpvillkor",
    "PAYMENT_METHOD_STEP": "Välj betalningsmetod",
    "PAY_STEP": "Gå till säker betalning",
    "OPT_EMAIL": "Jag vill ta del av erbjudanden från E.ON Webshop",
    "VIRTUAL_TERMS": "Jag samtycker till att det digitala presentkortet levereras omedelbart och är medveten om att detta innebär att jag inte längre har ångerrätt.",
    "DISCOUNT_CODE": {
      "HEADER": "Rabattkod",
      "PLACEHOLDER": "Ange rabattkod",
      "APPLY": "Använd",
      "REMOVE": "Ta bort",
    },
    "ADDRESS": {
      "ADDRESS": "Faktura & leveransinformation",
      "SHIPPING": "Leveransadress",
      "SHIP_TO_SAME_ADDRESS": "Leverera till samma adress",
    },
    "STEPS": {
      "CART": {
        "SHORT": "Varukorg",
        "LONG": "Varukorg",
      },
      "OVERVIEW": {
        "SHORT": "Kassa",
        "LONG": "Kassa",
      },
    },
  },
  "PAYMENT_METHODS": {
    "ALTAPAY": {
      "CARD": "Betala med kort",
    },
  },
  "CUSTOMER_SERVICE": {
    "TEXT": "Har du en fråga?",
    "LINK": "/faq",
    "ALT_TEXT": "FAQ",
  },
  "SUCCESS": {
    "HELMET_TITLE": "Orderbekräftelse",
    "TITLE": "Beställning registrerad",
    "SUB_TITLE": "Ordernummer %number",
    "BACK": "Fortsätt handla",
    "ORDER_OVERVIEW": "Orderöversikt",
    "NOT_FOUND_TITLE": "Ingen order hittades.",
    "NOT_FOUND_SUBTITLE": "Vänligen kontakta kundtjänst om detta är felaktigt.",
    "WHAT_NOW": "Så vad händer nu?",
    "STEPS": {
      "HEADING": "Beställning registrerad",
      "WHAT_NOW": "Så vad händer nu?",
      "LABEL": "Din beställning",
      "ORDER_ID": "Ordernummer %id",
      "QUESTIONS": {
        "HEADING": "Har du en fråga om din beställning?",
        "LABEL": "Gå till kundtjänst",
        "URL": "/faq",
      },
      "NORMAL": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse kommer att skickas till %email inom kort.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e‑post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse och dina digitala biljetter/värdekoder kommer att skickas till %email inom kort. Har du inte fått någon e‑post ber vi dig dubbelkolla ditt spam-filter innan du kontaktar kundservice.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e‑post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vi skickar dina digitala biljetter/värdekoder till %email inom kort. Din fysiska leverans skickas med DBSchenker. Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "Du kommer att få en orderbekräftelse till %email.",
        },
        "2": {
          "HEADING": "Digital leverans",
          "TEXT": "Vi skickar dina digitala biljetter/värdekoder till %email inom kort. Har du inte fått någon e‑post ber vi dig dubbelkolla ditt spam-filter innan du kontaktar kundservice.",
        },
      },
    },
    "CONTACT": {
      "TITLE": "Undrar du något?",
      "INFO": "Vi svarar på dina frågor angående leverans, produkter eller sortimentet inom 48 timmar på helgfria vardagar.",
      "LINK": "https://helpdesk.crossroads.se/?s=8b1b7f7e289a69a42e872427689875e4",
      "CREATE_TICKET": "Skriv till oss via vårt kontaktformulär",
      "OR": "eller",
      "REGRET_PURCHASE": "Ångra mitt köp",
    },
  },
  "CATEGORY": {
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Visar 1 produkt",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Visar %itemsCount produkter",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Laddar produkter...",
  },
  "PRODUCTLIST": {
    "EMPTY": "Det finns inga produkter att visa just nu",
  },
  "404": {
    "TITLE": "Sidan kunde inte hittas",
    "HEADING": "404",
    "TEXT": "Oops, den här sidan finns inte.",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfel",
    "TEXT": "<strong>Behöver du kontakta oss?</strong><br/> Skicka ett mail till <a href=\"mailto:kundservice@crossroads.se\">kundservice@crossroads.se</a>",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Sök: ",
    "PLACEHOLDER": "Sök efter produkter",
    "LABEL": "Tryck enter för att söka",
    "RESULTS": "Resultat för sökningen \"%query\"",
    "OPEN": "Öppna sök",
    "CLOSE": "Stäng sökmenyn",
  },
  "ICONS": {
    "CHEVRON": "Pil",
    "CROSS": "Kryss",
    "SEARCH": "Förstoringsglas",
    "CHECK": "Bock",
    "HOME": "Hus",
    "PLUS": "Plustecken",
    "MINUS": "Minustecken",
    "ECOMMERCE": "Trygg ehandel",
  },
  "HEADER": {
    "MAIN_NAVIGATION": "Huvudmeny",
    "SEARCH": "Sök",
    "CATEGORIES_TOGGLE": "Fler kategorier",
    "CLOSE_MENU": "Stäng menyn",
    "OPEN": "Öppna",
    "CLOSE": "Stäng",
  },
  "FOOTER": {
    "NAVIGATION": "Sidfotsmeny",
    "NEED_HELP": {
      "COOKIES": "Hantera cookies",
    },
    "COPYRIGHT": "E.ON webbshop drivs av <a href='https://www.awardit.com'>Awardit CLS AB</a>. Copyright © %year Awardit CLS AB. All Rights Reserved.",
    "ACCESSIBILITY": "Tillgänglighet",
  },
  "BREADCRUMBS": {
    "HOME": "Hem",
    "HOME_URL": "/",
  },
  "DRAWER": {
    "OPEN_SUBMENU": "Öppna undermeny",
    "CLOSE_SUBMENU": "Stäng undermeny",
  },
  "PRODUCT": {
    "ADD_TO_CART": "Köp nu",
    "OUT_OF_STOCK": "Ej i lager",
    "RELATED_PRODUCTS": "Relaterade produkter",
    "CROSS_SELL_PRODUCTS": "Andra gillade också",
    "OPTION_DROPDOWN_PLACEHOLDER": "Välj ett val",
    "CHANGE_IMAGE": "Byt bild",
    "ABOUT_BRAND": "Om %brand",
    "DESCRIPTION": "Produktbeskrivning",
    "EXTERNAL_SHOWCASE_DEFAULT": "Till produkten",
  },
  "FREE_SHIPPING": {
    "PROGRESS": "%value kr till gratis frakt",
    "COMPLETED": "Gratis frakt",
  },
  "PROGRESS_BAR": {
    "PROGRESS": "Framsteg: %percent%",
  },
  "VALIDATION": {
    "REQUIRED": "Obligatoriskt fält",
    "EMAIL": "Vänligen fyll i en korrekt e‑postadress",
    "PHONE": "Vänligen fyll i ett korrekt mobiltelefonnummer",
    "NUMERIC": "Fältet får bara innehålla nummer",
    "LENGTH_LT": "Fältet innehåller för många tecken",
    "POSTCODE": "Vänligen fyll i ett korrekt postnummer (XXX XX)",
    "NO_SHIPPING_GB": "Ej tillgängligt på grund av Brexit",
    "MISSING_FIELD": "Adress saknas, försök igen",
  },
  "COUPON_LIGHTBOX": {
    "TITLE": "Välkommen",
    "INFO": "Vi har lagt till din värdekod automatiskt, så att du slipper fylla i den manuellt i kassan. Fiffigt, va?",
    "CTA": "Börja handla",
  },
  "COOKIE_CONSENT": {
    "ALL": "Tillåt alla",
    "NECESSARY": "Tillåt nödvändiga",
    "SELECTED": "Tillåt urval",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nödvändiga",
    "STATISTICAL": "Statistiska",
    "MARKETING": "Marknadsföring",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "Ett okänt fel har uppstått. Vänligen ladda om sidan och försök igen.",
    "NETWORK_ERROR": "Anropet avbröts. Vänligen verifiera att du har en aktiv internetanslutning eller försök igen om en stund.",
    "PLACE_ORDER_CATCH": "Ett fel uppstod. Vänligen försök igen senare.",
    "AQUIRER_DECLINE": "Betalningen har nekats. Vänligen verifiera dina kort-/kontouppgifter.",

    "DISCOUNT_CODE_APPLIED": "Rabattkod applicerad.",
    "DISCOUNT_CODE_FAILURE": "Rabattkoden kunde inte appliceras, vänligt försök igen eller kontakta kundtjänst.",
    "DISCOUNT_CODE_REMOVE_FAILURE": "Rabattkoden kunde inte tas bort, vänligt försök igen eller kontakta kundtjänst.",

    "errorUnknownProduct": "Okänd produkt, vänligen försök igen.",

    "errorProductQuantityNotAvailable": "Det antal du angav finns inte tillgängligt just nu.",
    "errorProductNotInStock": "Produkten du försökte lägga i varukorgen finns dessvärre inte i lager just nu.",
    "errorProductMaxQuantity": "Det angivna antalet finns dessvärre inte i lager just nu.",
    "errorProductNotChosenVariant": "Vänligen välj %attributeLabel för att kunna lägga till produkten i din varukorg.",

    "errorFraudShop": "Det är inte möjligt att slutföra ett köp just nu",
    "errorFraudOrder": "Köpet är inte tillåtet. Kontakta support för mer information",
    "errorFraudProduct": "Gränsen har nåtts för en eller flera produkter i varukorgen. Kontakta support för mer information.",
    "errorFraudBlacklist": "Köpet är inte tillåtet. Kontakta support för mer information.",
    "errorDeclinedCard": "Kortet nekades.",

    "errorInvalidTelephone": "Ogiltigt telefonnummerformat.",

    "ITEM_REMOVED_FROM_CART": "%name togs bort från varukorgen eftersom att den inte längre finns i lager.",
    "NO_SHIPPING_GB": "På grund av Brexit och de nya reglerna kan vi för närvarande inte leverera till Storbritannien. Vi jobbar heltid med detta och hoppas på en lösning snart.",

    "ADVENT_CALENDAR": {
      "notModified": "E-postadressen är redan registrerad",
      "invalidEmail": "Ogiltig E-postadress",
      "success": "Du är nu registrerad",
    },
  },
};
